import { Injectable } from '@angular/core';
import { StudyDetails } from '../shared/study/model/study-details.model';
import { DatasetModel } from '../shared/dataset/model/dataset.model';
import { DATASET_TYPES_SUB_OBSERVATION_IDS, DatasetTypeEnum } from '../shared/dataset/model/dataset-type.enum';
import { StudySampleList } from '../entities/sample/sample-list.model';

@Injectable({ providedIn: 'root' })
export class StudyEditorContext {

    constructor() {
    }

    studyDetails?: StudyDetails;
    studyId: number;
    environmentDatasetId: number;
    allDatasets: DatasetModel[] = [];
    observationDatasets: DatasetModel[] = [];
    currentDataset: DatasetModel;
    germplasmListExists: boolean = false;
    studyHasCalculatedVariables = false;
    sampleLists: StudySampleList[] = [];
    existingStudyLevelVariableIds: number[] = [];
    existingEnvironmentLevelVariableIds: number[] = [];
    maxSubObservationUnitSets: number;
    maxSubObservationParentUnit: number;


    // TODO: Properly implement this
    hasGeneratedDesign(): boolean {
        return this.hasExperimentalDesign();
    }

    hasExperimentalDesign() {
        return this.studyDetails?.experimentalDesignDetail != null;
    }

    hasListOrSubObs() {
        const datasetTypeIds = DATASET_TYPES_SUB_OBSERVATION_IDS.map(datasetTypeId => datasetTypeId.valueOf());
        // TODO: replqce hasGermplasmList with method that checks if there's a sample list
        return this.allDatasets.filter((dataset) => datasetTypeIds.includes(dataset.datasetTypeId)).length > 0;
    }

    hasMeansDataset() {
        const meansDataset = this.allDatasets.find(dataset => {
            return dataset.datasetTypeId === DatasetTypeEnum.MEANS;
        });
        if (meansDataset) {
            return true;
        }
        return false;
    }

    hasSummaryStatisticsDataset() {
        const meansDataset = this.allDatasets.find(dataset => {
            return dataset.datasetTypeId === DatasetTypeEnum.SUMMARY_STATISTICS_DATA;
        });
        if (meansDataset) {
            return true;
        }
        return false;
    }

    hasGermplasmList() {
        return this.germplasmListExists;
    }

    getPlotDataset(): DatasetModel {
        if (this.observationDatasets) {
            return this.observationDatasets.find(dataset => {
                return dataset.datasetTypeId === DatasetTypeEnum.PLOT;
            });
        }
    }

    getEnvironmentDataset(): DatasetModel {
        if (this.allDatasets) {
            return this.allDatasets.find(dataset => {
                return dataset.datasetTypeId === DatasetTypeEnum.ENVIRONMENT;
            });
        }
        return null;
    }

    getSettingDataset(): DatasetModel {
        if (this.allDatasets) {
            return this.allDatasets.find(dataset => {
                return dataset.datasetTypeId === DatasetTypeEnum.STUDY_CONDITIONS;
            });
        }
        return null;
    }

    updateDataset(dataset: DatasetModel) {
        const index = this.observationDatasets.findIndex(d => d.datasetId === dataset.datasetId);
        if (index !== -1) {
            this.observationDatasets[index] = dataset;
        } else {
            this.observationDatasets.push(dataset);
        }
        this.currentDataset = dataset;
    }

    isLockedStudy() {
        return this.studyDetails && this.studyDetails.locked;
    }

    isStudyHasCalculatedVariables() {
        return this.studyHasCalculatedVariables;
    }

    reset() {
        this.studyDetails = undefined;
        this.studyId = undefined;
        this.environmentDatasetId = undefined;
        this.allDatasets = [];
        this.observationDatasets = [];
        this.currentDataset = undefined;
        this.germplasmListExists = false;
        this.studyHasCalculatedVariables = false;
        this.sampleLists = [];
    }
}
